import styled from 'styled-components'
export const HeaderTitle = styled.h1` 
font-size: 96px;
margin-top: 110px;
margin-bottom: 0; 
position:relative;
padding:40px 40px 0px 0px;

@media(max-width: 800px) {
  font-size:65px;
  margin-left:40px;
}
`

export const Subtitle = styled.h2`
  font-size: 48px;
  padding-left:150px;
  font-weight:400;
  margin:0px;
  background: linear-gradient(90deg, #00DBDE 30%, #FC00FF 80%);
  font-family:'Roboto';
  
  
-webkit-background-clip: text;
-webkit-text-fill-color: transparent;
`

export const InputRegister = styled.input`
width:380px;
height:68px;
font-size: 24px;
line-height: 28px;
text-align: right;
::-webkit-input-placeholder {
  text-align: center;
}
:-moz-placeholder {
  text-align: center;
}
border: 2.72272px solid #7918F2;
box-sizing: border-box;
background-color:#121212;
`

export const ButtonRegister = styled.button`

background: linear-gradient(90deg, #AC32E4 0%, #7918F2 48%, #4801FF 100%);
width:186px;
height:68px;
border:none;
margin-left:10px;

font-family: Poppins;
font-style: normal;
font-weight: 600;
font-size: 28px;
line-height: 42px;
/* identical to box height */

text-align: center;



color: #FFFFFF;
`

export const ProjectDescription = styled.div`
  width: 70%;
  margin: auto;
  text-align: justify; 
  align-items: center;
  margin-top:80px;
  position:relative;

  @media(max-width: 800px) {
    width:100%;
    margin-left:60px;
  }
  `

export const RevealText = styled.p`
  margin-top:0px;
  padding-top:0px;
  margin-bottom:40px;
  text-align:right;
  color:#7918F2;
  font-family:Roboto;
  font-size:20px;


`

export const MainSectionWrapper = styled.section`
  background-color: #121212;
  display: flex;
  justify-content: space-between;
  height: 100%;
  margin: 0px;
  padding: 0px;

  @media(max-width: 800px) {
    flex-direction: column;
    position: relative;
   

    div:first-child {
      height:0px;
    }

    div img {
      height:0px;
      width:0px;
    }
  }
`

export const ProjectDescriptionText = styled.p`
  fontSize: 17px;
  line-height: 23px; 
  margin-bottom: 0;
  textAlign: right;
`

export const SectionWrapperDescription = styled.div`
color: white;
text-align:center;
background-repeat: no-repeat;
background-position: right top;
`